import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, Tooltip } from '@dixa/lib-shared-habla';
export function DeliveryStatus({ code, text, isSuccess, }) {
    const getStatus = () => {
        if (!code) {
            return 'No events yet';
        }
        return `${isSuccess ? 'Success' : 'Failed'} (${code})`;
    };
    const getVariant = () => {
        if (!code) {
            return 'info';
        }
        return isSuccess ? 'success' : 'error';
    };
    return (_jsx(Tooltip, Object.assign({ content: text, dark: true, disabled: !code }, { children: _jsx(Badge, Object.assign({ size: "medium", variant: getVariant() }, { children: getStatus() })) })));
}
